// Store item in local storage
export const addToLocal = (key: string, value: string) => {
  localStorage.setItem(key, value)
}

// Check if item exists in local storage
export const checkLocal = (key: string) => {
  let item = localStorage.getItem(key)

  if (item) {
    return true
  } else {
    return false
  }
}

// Return item with key in local
export const getLocal = (key: string): string | null => {
  let item = localStorage.getItem(key)

  if (item) {
    return item
  } else {
    return null
  }
}

// Return item object with key in local
export const getLocalObject = (key: string) => {
  let item = checkLocal(key) ? JSON.parse(localStorage.getItem(key)!) : null

  return item
}
